import React, { useState } from "react";
import { Link } from "react-router-dom";
import { money, img } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { Plus } from "lucide-react";

export default function ProductCard({ product, index = 0 }) {
  const { addItem } = useCart();
  const [loaded, setLoaded] = useState(false);
  const priceLabel =
    product.price_min === product.price_max
      ? money(product.price_min)
      : `${money(product.price_min)} – ${money(product.price_max)}`;

  const singleVariation = product.variations.length === 1;
  const inStock = product.in_stock !== false;

  const quickAdd = (e) => {
    e.preventDefault();
    const v = product.variations[0];
    addItem({
      variationId: v.id,
      productId: product.id,
      slug: product.slug,
      name: product.name,
      variationName: v.name,
      price: v.price,
      image: product.images[0],
    });
  };

  return (
    <Link
      to={`/product/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group flex flex-col"
    >
      <div className="relative overflow-hidden rounded-t-[38%] rounded-b-2xl bg-sand shadow-[0_6px_30px_rgba(62,49,40,0.06)]">
        <div className="aspect-[3/4] w-full overflow-hidden">
          {!loaded && <div className="skeleton absolute inset-0" aria-hidden="true" />}
          <img
            src={img(product.images[0], 700)}
            alt={product.name}
            loading="lazy"
            onLoad={() => setLoaded(true)}
            className={`h-full w-full object-cover transition-all duration-700 ease-out group-hover:scale-105 ${loaded ? "opacity-100" : "opacity-0"}`}
          />
        </div>
        {product.is_manuka && (
          <span className="absolute left-3 top-3 z-[2] rounded-full bg-wood-900/90 px-3 py-1.5 text-xs font-semibold uppercase tracking-[0.15em] text-cream">
            MGO 234+
          </span>
        )}
        {!inStock && (
          <span className="absolute right-3 top-3 z-[2] rounded-full bg-rose px-3 py-1.5 text-xs font-semibold uppercase tracking-[0.1em] text-white">
            Sold out
          </span>
        )}
        {singleVariation && inStock && (
          <button
            onClick={quickAdd}
            data-testid={`quick-add-${product.slug}`}
            aria-label={`Add ${product.name} to cart`}
            className="absolute bottom-4 right-4 z-[2] flex h-12 w-12 translate-y-3 items-center justify-center rounded-full bg-wood-900 text-cream opacity-0 shadow-lg transition-all duration-300 hover:bg-honey-dark group-hover:translate-y-0 group-hover:opacity-100 focus-visible:translate-y-0 focus-visible:opacity-100"
          >
            <Plus size={20} />
          </button>
        )}
      </div>
      <div className="mt-4 flex flex-col gap-1 px-1">
        <h3 className="font-serif text-2xl leading-snug text-wood-900">{product.name}</h3>
        <span className="text-base font-semibold text-wood-700">{priceLabel}</span>
      </div>
    </Link>
  );
}
